const updateIndustryChartData = (state, payload) => {
  state.industryChartData = payload;
};
const updateIndustryDisplayMode = (state, payload) => {
  state.industryDisplayMode = payload;
};
const updateIndustryMaxValues = (state, payload) => {
  state.industryPageMaxPercent = payload.maxPercentage;
  state.industryPageMaxDecimal = payload.maxDecimal;
};
const updateIndustryLegend = (state, payload) => {
  state.industryLegendData = payload;
};
const updateTableSortColumn = (state, payload) => {
  state.tableSortColumn = payload;
};

export default {
  updateIndustryChartData,
  updateIndustryDisplayMode,
  updateIndustryMaxValues,
  updateIndustryLegend,
  updateTableSortColumn,
};
